import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ChildRegistrationListComp from '../../../../components/registrationPacket/ChildRegistrationListComp';
import ChildRegistrationFormComp from '../../../../components/registrationPacket/ChildRegistrationFormComp';
import { fetchRegistrationPackages, selectAllRegistrations, selectLoading } from '../../../../store/childRegistration/childRegistrationSlice';
import { getEffectiveStudentId } from '../../../../utilities/teacherModulePermissions';

const ChildRegistrationList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);

  const registrations = useSelector(selectAllRegistrations);
  const loading = useSelector(selectLoading);
  let profileData = useSelector((state) => state.setting.setting.user_data);
  profileData = profileData ? JSON.parse(profileData) : null;

  useEffect(() => {
    dispatch(fetchRegistrationPackages({ page: 1, limit: 100, student_id: getEffectiveStudentId(profileData) }));
  }, [dispatch]);

  const handleFormSuccess = () => {
    setShowForm(false);
    dispatch(fetchRegistrationPackages({ page: 1, limit: 100, student_id: getEffectiveStudentId(profileData) }));
  };

  const handleFormCancel = () => {
    setShowForm(false);
  };

  if (loading) {
    return (
      <Container>
        <Row>
          <Col sm={12}>
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  // Show form if user clicks add or if no registrations exist
  if (showForm || (!loading && registrations.length === 0)) {
    return (
      <Container>
        <Row>
          <Col sm={12}>
            {registrations.length > 0 && (
              <Card className="mb-3">
                <Card.Body>
                  <div className="d-flex justify-content-end">
                    <Button variant="secondary" onClick={handleFormCancel}>
                      <i className="material-symbols-outlined md-18">arrow_back</i> Back to List
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            )}
            <ChildRegistrationFormComp 
              onSubmit={handleFormSuccess}
              onCancel={handleFormCancel}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row>
        <Col sm={12}>
          <Card className="mb-3">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Child Registration</h4>
              </div>
            </Card.Body>
          </Card>
          <ChildRegistrationListComp viewMode="list" data={registrations} />
        </Col>
      </Row>
    </Container>
  );
};

export default ChildRegistrationList;
